var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOtherTokenIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "black",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0463 6C9.49057 6 8.04124 7.38891 8 9.39941V9.5H10.2562V9.39941C10.3057 8.51141 10.9391 7.93848 11.8963 7.93848C12.8453 7.93848 13.478 8.47068 13.478 9.22168C13.478 9.97268 13.1533 10.3604 12.0795 10.9824C10.9305 11.6364 10.4722 12.3633 10.5804 13.6553L10.5935 14H12.8034V13.6719C12.8034 12.8969 13.1117 12.5004 14.219 11.8789C15.3927 11.2084 16 10.3609 16 9.14941C16 7.28391 14.4273 6 12.0463 6ZM11.7463 15.5C10.8994 15.5 10.371 15.9769 10.371 16.7539C10.371 17.5239 10.8999 18 11.7463 18C12.5927 18 13.1145 17.5239 13.1145 16.7539C13.1145 15.9769 12.5932 15.5 11.7463 15.5Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherTokenIconLight);
export default __webpack_public_path__ + "static/media/other-token-icon-light.6d460dd9be1e7ab560b58fdb4f61089b.svg";
export { ForwardRef as ReactComponent };